import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOrderMSServiceNoteListData } from './mockData'
import type { IOrderMSServiceNote } from '~/types/note/models'

export const {
  getNotes: getOrderMSServiceNotes,
  postNote: postOrderMSServiceNote,
  patchNote: patchOrderMSServiceNote,
  deleteNote: deleteOrderMSServiceNote,
  handlers,
} = makeNoteAPIs<IOrderMSServiceNote>({
  apiPathEntityNamePrefix: 'ordermsservice',
  getNoteListDataFn: getOrderMSServiceNoteListData,
})
